let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let _ = require("ES/lib/lodash");
let Constants = require("../../../../../utils/Constants.js");
let AuthedUserSession = require('../../../../../utils/AuthedUserSession');
let ProOnly = require("../../../../widgets/ProOnly");


module.exports = dd.createClass({
    render() {
        let {event, Displaylists} = this.props;
        let is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
        let can_I_manage = AuthedUserSession.doIHaveAccess.admin.any(event.sids);

        if (AuthedUserSession.is_st_family) {
          return null;
        }

        return (is_limited_speaker || event.is_mp_event) ? null :
            ProOnly({
                    sids: event.sids,
                    custom_message: "Give your customers a red-carpet experience with the Client Portal."
                },
                dd.div({className: "clientportal", style: {marginTop: "3em"}},
                    dd.h4({className: "section-head"},
                        'Client Portal page',
                        dd.div({className: "pull-right"},
                            can_I_manage ? dd.a({
                                    href: "#/account_settings/client_portal/" + esUtils.encode_redir("/events/" + event.eid + "/contacts") + "/" + _.first(event.sids),
                                    className: "printlink"
                                },
                                dd.i({className: "fa fa-gear"}), " master settings"
                            ) : null
                        )
                    ),
                    dd.div({style: {marginLeft: '2em'}},

                        dd.div({className: 'alert alert-info'},
                            dd.p({style: {fontWeight: 'bold', fontFamily: 'monospace', fontSize: '0.8em', padding: "0.2em"}},
                                event.online_assistant_url,
                                dd.a({href: Constants.generateClientPortalMailtoForEvent(event, '', Displaylists), style: {marginLeft: "2em"}},
                                    dd.i({style: {fontSize: "1.25em"}, className: "fa fa-envelope-o"})
                                )
                            ),
                            dd.p({},
                                'Give the client this web address to let them see and update parts of this event.'
                            )
                        ),
                        dd.div({className: "instruction"},
                            dd.p({},
                                'Only customers who enter an ',
                                dd.span({style: {fontWeight: 'bold'}},
                                    'email address belonging to one of this event\'s contacts'
                                ),
                                ' will have access.'
                            ),
                            dd.p({className: "text-muted", style: {marginTop: "1em"}},
                                dd.a({href: "https://espeakers.com/wiki/Client_Portal", target: "_blank"},
                                    'Learn more about the Client Portal',
                                    dd.i({style: {marginLeft: "0.5em", fontSize: "1.0em"}, className: "fa fa-external-link"})
                                )
                            )
                        )
                    )
                )
            );
    }
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ClientPortal.js